import React, { useEffect, useState } from "react";
import api from "../lib/api";

// Renders an image stored in object storage, fetched as an authenticated blob.
export default function AuthImage({ path, alt = "", className = "", fallback = null }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let active = true;
    let objectUrl;
    if (!path) { setSrc(null); return; }
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((r) => { objectUrl = URL.createObjectURL(r.data); if (active) setSrc(objectUrl); })
      .catch(() => { if (active) setSrc(null); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [path]);

  if (!src) return fallback || <div className={`${className} bg-[#1b1b1d]`} />;
  return <img src={src} alt={alt} className={className} />;
}
